// @flow

export const CALL_PHONE_NUMBER = 'band-redux/zoom/CALL_PHONE_NUMBER';
export const JOIN_MEETING = 'band-redux/zoom/JOIN_MEETING';
export const SHARE_CONTENT = 'band-redux/zoom/SHARE_CONTENT';
export const START_MEETING = 'band-redux/zoom/START_MEETING';
export const END_MEETING = 'band-redux/zoom/END_MEETING';
export const UPDATE_ZOOM_MEETING = 'band-redux/zoom/UPDATE_MEETING';
